{
    "footnote-label": "Fußnoten",
    "footnote-back-label": "Hochspringen nach: {{index}}",
    "footnote-back-label-many": "Hochspringen nach: {{from}}-{{to}}",
    "store-different-origin": "Die Hyperbook-Datei stammt aus einer anderen Quelle {{origin}}. Möchten Sie sie trotzdem importieren?",
    "store-import-successful": "Die Hyperbook-Datei wurde erfolgreich importiert.",
    "store-not-supported-file-version": "Die Hyperbook-Datei hat eine nicht unterstützte Version {{version}}.",
    "store-reset-successful": "Das Hyperbook wurde erfolgreich zurückgesetzt.",
    "store-reset-confirm": "Sind Sie sicher, dass Sie das Hyperbook zurücksetzen möchten? Dadurch werden alle Ihre Daten entfernt.",
    "shell-search": "Suche",
    "shell-toggle-dark-mode": "Zwischen Dunkel- und Hellmodus wechseln",
    "shell-reset-hyperbook": "Das Hyperbook zurücksetzen",
    "shell-import-hyperbook": "Das Hyperbook aus einer Datei importieren",
    "shell-export-hyperbook": "Das Hyperbook in eine Datei exportieren",
    "breadcrumb-navigation": "Brotkrümelnavigation",
    "breadcrumb-home": "Startseite",
    "qr-code": "QR-Code",
    "p5-update": "Aktualisieren",
    "p5-code-preview": "Code-Vorschau",
    "p5-reset": "Zurücksetzen",
    "p5-copy": "Kopieren",
    "p5-download": "Herunterladen",
    "abc-music-reset": "Zurücksetzen",
    "abc-music-copy": "Kopieren",
    "abc-music-download": "Herunterladen",
    "table-of-contents": "Inhaltsverzeichnis",
    "audio-play": "Abspielen/Pause",
    "archive-offline": "Offline",
    "download-offline": "Offline",
    "ide-fullscreen-enter": "Vollbild",
    "ide-fullscreen-exit": "Vollbild beenden",
    "pyide-run": "Ausführen",
    "pyide-running": "Wird ausgeführt ...",
    "pyide-running-click-to-stop": "Wird ausgeführt (Klicken zum Stoppen) ...",
    "pyide-running-refresh-to-stop": "Wird ausgeführt (Aktualisieren zum Stoppen) ...",
    "pyide-test": "Testen",
    "pyide-testing": "Test läuft ...",
    "pyide-test-running-click-to-stop": "Test läuft (Klicken zum Stoppen) ...",
    "pyide-test-running-refresh-to-stop": "Test läuft (Aktualisieren zum Stoppen) ...",
    "pyide-stop": "Stoppen",
    "pyide-stop-refresh": "Stoppen (Neuladen)",
    "pyide-locked-other-instance-running": "Eine andere PyIDE-Instanz läuft",
    "pyide-stopping": "Wird gestoppt ...",
    "pyide-stop-reloading": "Zum Stoppen ist auf dieser Seite ein Neuladen nötig. Seite wird neu geladen...",
    "pyide-stop-refresh-required": "Stopp angefordert. Wenn die Ausführung nicht stoppt, Seite neu laden oder COOP/COEP-Header aktivieren.",
    "pyide-output": "Ausgabe",
    "pyide-canvas": "Canvas",
    "pyide-input": "Eingabe",
    "pyide-input-prompt": "Eingabe erforderlich:",
    "pyide-reset": "Zurücksetzen",
    "pyide-copy": "Kopieren",
    "pyide-download": "Herunterladen",
    "slideshow-previous": "Zurück",
    "slideshow-next": "Weiter",
    "slideshow-jump-to": "Springe zu {{index}}",
    "toggle-bookmark": "Lesezeichen umschalten",
    "shell-share": "Teilen",
    "share-dialog-title": "Teilbare URL erstellen",
    "share-dialog-standalone": "Standalone-Modus",
    "share-dialog-select-sections": "Abschnitte auswählen",
    "share-dialog-copy-url": "Teilbare URL kopieren",
    "share-dialog-url-copied": "URL in Zwischenablage kopiert!",
    "webide-code-preview": "Code-Vorschau",
    "webide-html": "HTML",
    "webide-css": "CSS",
    "webide-js": "JS",
    "webide-reset": "Zurücksetzen",
    "webide-reset-prompt": "Sind Sie sicher, dass Sie den Code zurücksetzen möchten?",
    "webide-copy": "Kopieren",
    "webide-download": "Herunterladen",
    "typst-code": "Typst",
    "typst-reset": "Zurücksetzen",
    "typst-reset-prompt": "Sind Sie sicher, dass Sie den Code zurücksetzen möchten?",
    "typst-download-pdf": "PDF herunterladen",
    "typst-pdf-error": "Fehler beim PDF-Export",
    "typst-download-project": "Projekt herunterladen",
    "typst-loading": "Typst wird geladen...",
    "typst-add-source-file": "Quelldatei hinzufügen",
    "typst-add-binary-file": "Binärdatei hinzufügen",
    "typst-source": "Quelle",
    "typst-binary": "Binär",
    "typst-add": "Hinzufügen",
    "typst-delete-file": "Datei löschen",
    "typst-delete-confirm": "Löschen",
    "typst-filename-prompt": "Dateiname eingeben (z.B. helper.typ):",
    "typst-filename-error": "Dateiname muss auf .typ oder .typst enden",
    "typst-filename-exists": "Datei existiert bereits",
    "typst-file-replace": "Existierende Datei ersetzen?",
    "typst-binary-files": "Binärdateien",
    "typst-no-binary-files": "Keine Binärdateien",
    "openscad-preview": "Vorschau",
    "openscad-render": "Rendern",
    "openscad-copy": "Kopieren",
    "openscad-copy-done": "Code kopiert",
    "openscad-download": "Herunterladen",
    "openscad-download-format": "Download-Format",
    "openscad-download-stl": "STL herunterladen",
    "openscad-download-ready": "Download bereit",
    "openscad-reset": "Zurücksetzen",
    "openscad-reset-prompt": "Sind Sie sicher, dass Sie den Code zurücksetzen möchten?",
    "openscad-rendering": "Rendern ...",
    "openscad-render-success": "Rendern abgeschlossen",
    "openscad-render-failed": "OpenSCAD-Rendern fehlgeschlagen",
    "openscad-params-object": "Parameter müssen ein JSON-Objekt sein",
    "openscad-params-loading": "Parameter werden geladen...",
    "openscad-params-none": "Keine Parameter",
    "openscad-parameters": "Parameter",
    "openscad-binary-files": "Binärdateien",
    "openscad-no-binary-files": "Keine Binärdateien",
    "openscad-add-binary-file": "Binärdatei hinzufügen",
    "openscad-add": "Hinzufügen",
    "openscad-file-replace": "Existierende Datei ersetzen?",
    "user-login-title": "Anmelden",
    "user-username": "Benutzername",
    "user-password": "Passwort",
    "user-login": "Anmelden",
    "user-info-title": "Benutzer Info",
    "user-status": "Status",
    "user-saved": "Gespeichert",
    "user-saving": "Speichere...",
    "user-save-error": "Fehler beim Speichern",
    "user-unsaved": "Ungespeicherte Änderungen",
    "user-offline": "Offline",
    "user-offline-queued": "Lokal gespeichert",
    "user-save": "Jetzt speichern",
    "user-logout": "Abmelden",
    "user-login-required": "Benutzername und Passwort erforderlich",
    "user-login-failed": "Anmeldung fehlgeschlagen",
    "user-logout-confirm": "Möchten Sie sich wirklich abmelden?",
    "user-readonly": "Nur-Lesen-Modus",
    "user-impersonating": "Angemeldet als",
    "user-exit-impersonation": "Identitätswechsel beenden",
    "consent-youtube-text": "Bei einem Klick auf den Play-Button wird ein YouTube-Video über YouTube-NoCookie geladen. Dennoch findet der Verbindungsaufbau statt und die dafür notwendigen Daten werden übertragen.",
    "consent-youtube-nocookie": "Wir verwenden YouTube-NoCookie, um Ihre Privatsphäre zu schützen.",
    "consent-youtube-always": "YouTube-Videos immer zulassen",
    "consent-youtube-accept": "Akzeptieren und abspielen",
    "consent-embed-text": "Hier sollen Inhalte einer externen Internetseite geladen werden.",
    "consent-embed-personal-data": "Die externe Internetseite kann möglicherweise personenbezogene Daten erheben.",
    "consent-embed-always": "Inhalte von {{domain}} immer zulassen",
    "consent-embed-accept": "Inhalte laden"
}
